import React, { PropsWithChildren } from "react";

import { Navigate } from "react-router-dom";
import { routesConstants } from "../utils/constants";
import { useSelector } from "react-redux";
import { RootState } from "../services/redux/store";

const ProjectAuthProtectedRoute: React.FC<
  PropsWithChildren<{
    children: React.ReactNode;
  }>
> = ({ children }) => {
  const { project_data } = useSelector((store: RootState) => store.authStore);

  return project_data.projectAccessToken ? (
    <>{children}</>
  ) : (
    <Navigate to={routesConstants.projects} />
  );
};

export default ProjectAuthProtectedRoute;
